module.exports = __webpack_public_path__ + "static/media/slideshow-25.44f5cb3f.jpeg";